import React from 'react'
const StarIcon = () => {
  return (
    <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.96.677c.308-.903 1.584-.903 1.893 0l1.695 4.964a1 1 0 0 0 .623.623l4.964 1.695c.902.308.902 1.585 0 1.893l-4.964 1.695a1 1 0 0 0-.623.623l-1.695 4.964c-.309.903-1.585.903-1.893 0L6.265 12.17a1 1 0 0 0-.623-.623L.677 9.852c-.902-.308-.902-1.585 0-1.893l4.965-1.695a1 1 0 0 0 .623-.623z"
        fill="#e0ff46"
      />
    </svg>
  )
}

export { StarIcon }
